import CalendarLocale from 'rc-picker/lib/locale/fr_FR';
var timePickerLocale = {
  placeholder: "Sélectionner l'heure",
  rangePlaceholder: ['Heure de début', 'Heure de fin']
};
// Merge into a locale object
var locale = {
  lang: Object.assign({
    placeholder: 'Sélectionner une date',
    yearPlaceholder: 'Sélectionner une année',
    quarterPlaceholder: 'Sélectionner un trimestre',
    quarterFormat: 'Tri[m]. Q',
    monthPlaceholder: 'Sélectionner un mois',
    weekPlaceholder: 'Sélectionner une semaine',
    rangePlaceholder: ['Date de début', 'Date de fin'],
    rangeYearPlaceholder: ['Année de début', 'Année de fin'],
    rangeMonthPlaceholder: ['Mois de début', 'Mois de fin'],
    rangeWeekPlaceholder: ['Semaine de début', 'Semaine de fin'],
    rangeQuarterPlaceholder: ['Trimestre de début', 'Trimestre de fin']
  }, CalendarLocale),
  timePickerLocale: timePickerLocale
};
export default locale;